module.exports = __webpack_public_path__ + "static/media/wide2.dee409d4.jpeg";